export default __webpack_public_path__ + "static/media/transfer.2bc65326.svg";